import React from "react";

export default function FormattedDate(props) {
  let day = props.date.getDay();
  let hours = props.date.getHours();
  let minutes = props.date.getMinutes();
  let year = props.date.getFullYear();
  let month = props.date.getMonth() + 1;
  let date = props.date.getDate();

  let nameDay = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  };

  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  if (month <= 9) {
    month = `0${month}`;
  }

  if (date <= 9) {
    date = `0${date}`;
  }

  let fullDate = `${date}.${month}.${year}`;


  return (
    <div>
      <div id="date">{fullDate} </div>
      <div>{nameDay[[day]]}</div>
      <small>
        <em>Last update: </em>
      </small>
      <span className="time">
        {hours}:{minutes}
      </span>
    </div>
  );
}
